{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-11T23:44:02.475Z","source":"place-details"}